"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
var User_1 = require("./User");
var Client_1 = require("./Client");
var initialize = function (environmentKey, user, options) {
    // TODO: implement logger
    if (!window) {
        console.log('Window is not defined, try initializing in a browser context');
    }
    if (!environmentKey) {
        throw new Error('Missing environment key! Call initialize with a valid environment key');
    }
    var dvcUser = new User_1.DVCUser(user);
    var client = new Client_1.DVCClient(environmentKey, dvcUser, options);
    client.onClientInitialized()
        .then(function () { return console.log('Successfully initialized DevCycle!'); })
        .catch(function (err) { return console.log("Error initializing DevCycle: ".concat(err)); });
    window.addEventListener('pagehide', function () {
        client.flushEvents();
    });
    return client;
};
exports.initialize = initialize;
exports.default = { initialize: exports.initialize };
//# sourceMappingURL=index.js.map